import React, { useEffect, useState } from 'react'
import { getLeagueTable , getNextMatches} from '../../services/api/api.js'
import { FaHeart } from 'react-icons/fa';
import createPersistedState from 'use-persisted-state';

import './Brasileirao.css';

const  converteDataUTC = (utcDate) => {
    const date = new Date(utcDate)
    return new Intl.DateTimeFormat(['ban', 'id']).format(date)
  }

const Brasileirao = () => {

    const useCounterState = createPersistedState('favorites');

    const ToogleFavorities = (time) => {
        if(favorites.includes(time)){
            setFavorities(  favorites.filter( (f) => f !== time ))
        }else{
            setFavorities([...favorites,time])
        }
    }

    const [loading,setLoading] =  useState(false);
    const [leagueTableState,setLeagueTable] =  useState();
    const [nextMatchesState, setNextMatches] = useState();
    const [favorites, setFavorities] = useCounterState([]);

    useEffect( () => {   
        const leagueId = 2013
        console.log('leagueid',2013)
        const load = async () => {
            setLoading(true)
            const promises = [
                getLeagueTable(leagueId),
                getNextMatches(leagueId)
            ]
            const [leagueTable , nextMatches ] = await Promise.all(promises)
            console.log('nextMatches',nextMatches.matches)
            setLeagueTable(leagueTable.standings[0].table);
            setNextMatches(nextMatches.matches);
            setLoading(false);
        }
        load()
    },[])

    return (
    <div id="brasileirao">
        {loading && <h1>Carregando</h1>}
        {!loading && leagueTableState && (
            <>
                <h1>Tabela</h1>
                <div>
                    <table className="stripe-vertical">
                        <thead>
                            <tr>
                                <th />
                                <th />
                                <th />
                                <th>P</th>
                                <th>J</th>
                                <th>V</th>
                                <th>E</th>
                                <th>D</th>
                                <th>GP</th>
                                <th>GC</th>
                                <th>SG</th>
                            </tr>
                        </thead>
                        <tbody>
                            {leagueTableState.map( (r) => (
                                <tr key={r.position}>
                                    <td><button onClick={ () => ToogleFavorities(r.team.name)}>{favorites.includes(r.team.name) ? "-" : "+"}</button></td>
                                    <td>{r.position}</td>
                                    <td>{r.team.name}</td>
                                    <td>{r.points}</td>
                                    <td>{r.playedGames}</td>
                                    <td>{r.won}</td>
                                    <td>{r.draw}</td>
                                    <td>{r.lost}</td>
                                    <td>{r.goalsFor}</td>
                                    <td>{r.goalsAgainst}</td>
                                    <td>{r.goalDifference}</td>
                                </tr>

                            ))}
                        </tbody>
                    </table>
                </div>
                <div>
                    <h1>Próximos Jogos</h1>
                    <div>
                        <table>
                            <thead>
                                <tr>
                                    <th />
                                    <th>Partida</th>
                                    <th>Horário</th>
                                </tr>
                            </thead>
                            <tbody>
                                {  nextMatchesState.map( (n) => {
                                   return (
                                        <tr key={n.id}>
                                            <td>{ ( favorites.includes(n.homeTeam.name) || favorites.includes(n.homeTeam.name)) ? <FaHeart />  : ""  } </td>
                                            <td> {n.homeTeam.name} x {n.awayTeam.name}</td>
                                            <td> {converteDataUTC(n.utcDate)}</td> 
                                        </tr>
                                   )
                                }) }
                                </tbody>
                        </table>
                    </div>
                </div>
            </>
            )}
    </div>
    )
}
export default Brasileirao